import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceSummaryNoHistoryPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryNoHistory = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium};
            background: ${theme.star.raceSummary.bgColorQuaternary};
        `;
    }
    return css``;
};

export const RaceSummaryNoHistory = withConfig(theme => styled('div', { label: 'RaceSummaryNoHistory' }) <RaceSummaryNoHistoryPropsType>`
    ${({ variant }): SerializedStyles=> setRaceSummaryNoHistory(variant, theme)};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3;
`);

interface RaceSummaryListWrapperPropsType {
    isOpen: boolean;
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryListWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isOpen: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: ${isOpen ? 'flex' : 'none' };
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
        `;
    }
    return css`
        display: ${isOpen ? 'block' : 'none' };
    `;
};

export const RaceSummaryListWrapper = withConfig(theme => styled('ul', { label: 'RaceSummaryListWrapper' })<RaceSummaryListWrapperPropsType> `
    ${({ variant, isOpen }): SerializedStyles=> setRaceSummaryListWrapper(variant, theme, isOpen)};
`);

interface HorseRacingRowWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setHorseRacingRowWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

export const HorseRacingRowWrapper = withConfig(theme => styled('div', { label: 'HorseRacingRowWrapper' })<HorseRacingRowWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setHorseRacingRowWrapper(variant, theme)};
`);
